import { axiosInstance } from '../axios';

export interface ValidateCpfPhotoPayload {
  cpf: string;
  patientKey: string;
  photo: Blob;
}

export interface ValidateCpfPhotoResponse {
  success: boolean;
  message: string;
}

export async function validateCpfWithPhoto(payload: ValidateCpfPhotoPayload): Promise<ValidateCpfPhotoResponse> {
  const formData = new FormData();
  formData.append('cpf', payload.cpf);
  formData.append('patient_key', payload.patientKey);
  formData.append('photo', payload.photo, 'cpf-document.jpg');

  return axiosInstance.post('/telemedicine/validate-cpf-photo/', formData).then(({ data }) => data);
}

export interface SchedulingSlot {
  slot_id: string;
  time: string;
}

export interface SchedulingDay {
  date: string;
  status: string;
  slots: SchedulingSlot[];
}

export interface GetAvailableSlotsResponse {
  data: SchedulingDay[];
}

/** Dados escolhidos no passo de agendamento, ainda não enviados — a reserva de fato só
 * acontece quando o paciente confirma no passo seguinte (resumo + "Confirmar agendamento"). */
export interface BookingDraft {
  date: string;
  slot: SchedulingSlot;
  name: string;
  email: string;
  phone: string;
  birthDate: string;
  cpf: string;
}

/**
 * Horários da agenda da clínica (Clínico Geral) — sem seleção de médico: o backend
 * agrega e resolve o profissional por trás de cada horário automaticamente.
 */
export async function getAvailableSlots(date?: string): Promise<GetAvailableSlotsResponse> {
  return axiosInstance
    .get('/telemedicine/scheduling/available-slots/', { params: date ? { date } : {} })
    .then(({ data }) => data);
}

export interface BookAppointmentPatient {
  document: string;
  full_name: string;
  birth_date: string;
  phone: string;
  email: string;
}

export interface BookAppointmentSlot {
  date: string;
  time: string;
}

export interface BookAppointmentPayload {
  patient: BookAppointmentPatient;
  slot: BookAppointmentSlot;
}

export interface BookAppointmentResponse {
  appointment_id: number | string;
  id: number | string | null;
  status: string;
  [key: string]: unknown;
}

export async function bookAppointment(payload: BookAppointmentPayload): Promise<BookAppointmentResponse> {
  return axiosInstance.post('/telemedicine/scheduling/book/', payload).then(({ data }) => data);
}

export interface MyAppointment {
  id: number | string;
  status: string;
  date: string;
  time: string;
  patient_name: string;
  [key: string]: unknown;
}

export interface GetMyAppointmentResponse {
  data: MyAppointment | null;
}

export async function getMyOpenAppointment(): Promise<GetMyAppointmentResponse> {
  return axiosInstance.get('/telemedicine/scheduling/my-appointment/').then(({ data }) => data);
}

export async function cancelMyAppointment(appointmentId: number | string): Promise<MyAppointment> {
  return axiosInstance
    .post('/telemedicine/scheduling/cancel/', { appointment_id: appointmentId })
    .then(({ data }) => data);
}
